import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { appendSearchParamsToURL } from "@/utils/utils";
import { validationConstants, validationFunctions } from "@/utils/validationUtils";
import { App as AntApp, Button, Card, Input } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import AntIcon from "../../../common/components/icons/AntIcon";
import { SearchPageRequest } from "../../../common/types";
import { AdminUserListTableView } from "../components/views/list/AdminUserListTableView";
import { ADMIN_USER_ROUTE_PATHS } from "../paths";

export const AdminUserListContainer = () => {
  const { t } = useTranslation();
  const { message } = AntApp.useApp();

  const navigate = useNavigate();

  const searchParams = useFilterSearchParams<SearchPageRequest>();

  const handleSearchSubmit = (keyword: string) => {
    if (validationFunctions.validateSearchKeyword(keyword)) {
      navigate(appendSearchParamsToURL({ pageIndex: undefined, keyword: keyword !== "" ? keyword : undefined }), {
        replace: true,
      });
    } else {
      message.error(
        t("validation.size", {
          min: validationConstants.SEARCH_KEYWORD_MIN_LENGTH,
          max: validationConstants.SEARCH_KEYWORD_MAX_LENGTH,
        }),
      );
    }
  };

  const handleCreateClick = () => {
    navigate(ADMIN_USER_ROUTE_PATHS.create.to);
  };

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={<h2>{t("user.titles.list")}</h2>}
        extra={
          <>
            <Button
              className="margin-right-small"
              type="primary"
              icon={<AntIcon type="plus" />}
              onClick={handleCreateClick}
            >
              {t("user.actions.createUser")}
            </Button>
            <Input.Search
              style={{ width: 350 }}
              enterButton
              allowClear
              placeholder={t("user.helpers.userSearchHint")}
              defaultValue={searchParams.keyword}
              onSearch={handleSearchSubmit}
            />
          </>
        }
      >
        <AdminUserListTableView searchParams={searchParams} />
      </Card>
    </ContentWrapper>
  );
};
